import React from 'react';
import Input from "../../../../../core/Inputs/DefaultInput";

export default function MultipleQuestions() {
    return (
        <div className="question-wrapper">
            <div className="heading">
                <h3>Q1. What are the solution(s) offered by your company?</h3>
            </div>
            <div className="question-list-wrapper">
                <ul className='question-list'>
                    <li>
                        <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" name="questionCheck" type="radio" id="questionCheck1" defaultChecked />
                            <label htmlFor="questionCheck1">Once a day</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" name="questionCheck" type="radio" id="questionCheck2" />
                            <label htmlFor="questionCheck2">Once a week</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" name="questionCheck" type="radio" id="questionCheck3" />
                            <label htmlFor="questionCheck3">Once a month</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" name="questionCheck" type="radio" id="questionCheck4" />
                            <label htmlFor="questionCheck4">Once a quarter</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" name="questionCheck" type="radio" id="questionCheck5" />
                            <label htmlFor="questionCheck5">All of the above</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    )
}
